module.exports = __webpack_public_path__ + "static/media/montiapp-login-dark.d1cc93e1.jpg";